<app-activity-card
  [headerTitle]="headerTitle"
  [expirationDate]="expirationDate"
  [picture]="picture"
  [businessId]="businessId"
  [couponStatus]="couponStatus"
  [usedDate]="usedDate"
  [timelineDisabled]="timelineDisabled"
  [note]="note"
  activityType="coupon"
  [id]="id"
  [businessStatus]="this.businessStatus"
  [viewOnly]="viewOnly"
  (closeStatusEvent)="closeCouponStatus()"
  [disabledAt]="this.disabledAt"
>
  <div class="coupon-card-root">
    <div class="left-block">
      <span class="printer-model" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ printerModel }}</span>
      <span class="description" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ rewardName }}</span>
      <span class="serial" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ serial }}</span>
      <span class="coupon-code" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ couponCode }}</span>
      <span class="reclaimed-date" [ngClass]="{ 'text-disabled' : timelineDisabled }"
        >{{ couponReclaimedText | transloco }} {{ reclaimedDate | date : 'd MMM y' : '' : language }}</span
      >
      <span class="reclaimed-date" [ngClass]="{ 'text-disabled' : timelineDisabled }"
      >{{ couponExpiringText | transloco }} {{ expirationDate | date : 'd MMM y' : '' : language }}</span
      >
    </div>
    <div class="right-block">
      <app-sticker-icon class="stars" small icon="stars">
        {{ cost | number: '':language }}
      </app-sticker-icon>
      <app-chip
        small
        *ngIf="!viewOnly && !isCallCenterAgent"
        (selectFilterClick)="toggleCouponStatus()"
        class="button change-coupon-status"
        filled
        [defaultCursor]="statusDisabled"
        [gray]="statusDisabled"
        >{{ (isRedeemed ? editRedeemDataText : changeCouponStatusText) | transloco }}</app-chip
      >
    </div>
  </div>
  <div class="popup-preamble">
    <app-coupon-status
      (closeClick)="closeCouponStatus()"
      (updateCoupon)="updateCouponData($event)"
      [ngClass]="{ visible: showCouponStatus }"
      [couponData]="couponData"
      [businessStatus]="businessStatus"
      [disabledAt]="this.disabledAt"
    ></app-coupon-status>
  </div>
</app-activity-card>
